<template>
    <div class="map" :id="initId">
      <div class="loction center">
          经度：{{longitude_x}}纬度：{{longitude_y}}
      </div>
      <div class="changeMap">
          <el-select class="xixi" v-model="value" @change="changeValue" placeholder="请选择" size="mini">
              <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.fileCreateTime"
              :value="item.fileName">
              </el-option>
          </el-select>
      </div>
    </div>
</template>

<script>
import axios from '@/utils/axios.min'
let viewer
const Cesium = window.Cesium
export default {
    props:{
        initId:{
            type:String,
            default:'map'
        },
        timeRange:{
            type:Object
        },
        isplay:{
            type:Boolean
        },
        is2d:{
            type:Boolean
        },
        url: {
          type: String
        },
        productFileList:{
            type: Array
        },
        collections: {
          type: Array
        }
    },
    components:{
    },
    data(){
        return{
            options:[],
            value:'',
            longitude_x:'',
            longitude_y:'',
            startTime:'',
            endTime:'',
            nowTime:'',
            showTime:null,
            AllCollection:[
              "http://192.168.1.8:8090/iserver/services/map-slie/rest/maps/T2017_SLIE_3976"
            ],
            layerIndex: 0,
            isFirst:true,
            loading:false,
        }
    },
    watch:{
      timeRange(val){
        if(val){
          this.isFirst = true
        }
      },
      isplay(val){
          if(!val&&this.is2d){
              if(this.isFirst){
                  this.AllCollection = []
                  this.layerIndex = 0
                  this.getLIST()
                  this.isFirst = false
              }else{
                this.addHeat()
              }
          }else{
              clearInterval(this.showTime)
          }
      }
    },
    destroyed(){
        clearInterval(this.showTime)
    },
    methods:{
        changeValue(val){
            this.TimeLayerGroup.clearLayers()
            let first = val.split('.')[0]
            tiledMapLayer(this.iserverHeader+this.url+'/'+first,{noWrap:true}).addTo(this.TimeLayerGroup)
        },
        opaContraol(oldNum,newNum,Oldlayer,newPM){
            let that = this
            console.log(oldNum,newNum);
            this.showTime = setInterval(function(){
                Oldlayer.alpha = 0
                newPM.alpha = 0.75
                clearInterval(that.showTime)
                viewer.imageryLayers.remove(Oldlayer)
                that.addHeat()
            },150)
        },
        addHeat(){
          const rootUrl = this.iserverLayerHeader + this.url + '/collections/' + this.AllCollection[this.layerIndex].collection + '/tile.png?transparent=true&z={zindex}&x={x}&y={y}&width=256&height=256&' + 'names=' + this.AllCollection[this.layerIndex].name

          let tilelayerProvider = new Cesium.UrlTemplateImageryProvider({
            url: rootUrl,
            subdomains:["8090","8091","8092"],
            tilingScheme:new Cesium.GeographicTilingScheme({
              ellipsoid:Cesium.Ellipsoid.WGS84,
              numberOfLevelZeroTilesX:2,
              numberOfLevelZeroTilesY:1,
            }),
            customTags: {
              zindex: function(imageryProvider, x, y, level) {
                return level + 1
              }
            }
          });

          const imgLayer = viewer.imageryLayers.addImageryProvider(tilelayerProvider)
          // imgLayer.transparentBackColor = Cesium.Color.WHITE
          // imgLayer.transparentBackColorTolerance = 0.5
          imgLayer.alpha = 0

          this.opaContraol(1,0.1,viewer.imageryLayers._layers[1],viewer.imageryLayers._layers[2])
          if (this.layerIndex === this.AllCollection.length - 1) {
            this.layerIndex = 0
            return
          }
          this.layerIndex++
        },
        getLIST2(){
          const that = this
          const startTime = this.timeRange[0].getFullYear() + '-' + (this.timeRange[0].getMonth() + 1) + '-' + this.timeRange[0].getDate() + ' 00:00:00'
          const endTime = this.timeRange[1].getFullYear() + '-' + (this.timeRange[1].getMonth() + 1) + '-' + this.timeRange[1].getDate() + ' 23:59:59'
          const collectionNames = []
          this.collections.forEach(item => {
            collectionNames.push(item.resourceName)
          })
          const url = this.iserverHeader + this.url + '/search.json?collections=' + collectionNames.toString() + '&query=createtime Between\'' + startTime + '\' AND \'' + endTime + '\''
          axios.get(url).then(res => {
            res.data.features.forEach(feature => {
              that.AllCollection.push({
                collection: feature.collection,
                name: feature.assets.data.title,
                time:feature.properties.createtime
              })
            })
            const rootUrl = this.iserverLayerHeader + this.url + '/collections/' + that.AllCollection[that.layerIndex].collection + '/tile.png?z={zindex}&x={x}&y={y}&width=256&height=256&' + 'names=' + that.AllCollection[this.layerIndex].name
            //开始前预加7张
            for(let i = 0;i<2;i++){
              let tilelayerProvider = new Cesium.UrlTemplateImageryProvider({
                url: rootUrl,
                subdomains:["8090","8091","8092"],
                tilingScheme:new Cesium.GeographicTilingScheme({
                  ellipsoid:Cesium.Ellipsoid.WGS84,
                  numberOfLevelZeroTilesX:2,
                  numberOfLevelZeroTilesY:1,
                }),
                customTags: {
                  zindex: function(imageryProvider, x, y, level) {
                    return level + 1
                  }
                }
              });

              const imgLayer = viewer.imageryLayers.addImageryProvider(tilelayerProvider)
              imgLayer.transparentBackColor = Cesium.Color.WHITE
              imgLayer.transparentBackColorTolerance = 0.5
              if(i===0){
                imgLayer.alpha = 0.75
              }else{
                imgLayer.alpha = 0
              }
              that.layerIndex++
            }
            that.addHeat()
          })
        },
        addOne(){
          const that = this
          const startTime = this.timeRange[0].getFullYear() + '-' + (this.timeRange[0].getMonth() + 1) + '-' + this.timeRange[0].getDate() + ' 00:00:00'
          const endTime = this.timeRange[0].getFullYear() + '-' + (this.timeRange[0].getMonth() + 1) + '-' + this.timeRange[0].getDate() + ' 00:10:00'
          const collectionNames = []
          this.collections.forEach(item => {
            collectionNames.push(item.resourceName)
          })
          const url = this.iserverHeader + this.url + '/search.json?collections=' + collectionNames.toString() + '&query=createtime Between\'' + startTime + '\' AND \'' + endTime + '\''
          axios.get(url).then(res => {
            res.data.features.forEach(feature => {
              that.AllCollection.push({
                collection: feature.collection,
                name: feature.assets.data.title,
                time:feature.properties.createtime
              })
            })
            const rootUrl = this.iserverLayerHeader + this.url + '/collections/' + that.AllCollection[this.layerIndex].collection + '/tile.png?z={zindex}&x={x}&y={y}&width=256&height=256&' + 'names=' + that.AllCollection[this.layerIndex].name
            //开始前预加7张
            let tilelayerProvider = new Cesium.UrlTemplateImageryProvider({
              url: rootUrl,
              subdomains:["8090","8091","8092"],
              tilingScheme:new Cesium.GeographicTilingScheme({
                ellipsoid:Cesium.Ellipsoid.WGS84,
                numberOfLevelZeroTilesX:2,
                numberOfLevelZeroTilesY:1,
              }),
              customTags: {
                zindex: function(imageryProvider, x, y, level) {
                  return level + 1
                }
              }
            });

            that.AllCollection.splice(1,that.AllCollection.length-1)

            const imgLayer = viewer.imageryLayers.addImageryProvider(tilelayerProvider)
            imgLayer.transparentBackColor = Cesium.Color.WHITE
            imgLayer.transparentBackColorTolerance = 0.5
            imgLayer.alpha = 0.75
            that.layerIndex++
          })
        },
        initMap(){
          let that = this
            Cesium.Ion.defaultAccessToken = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiI4NjJhZTlhZC00ZjE4LTRhYjYtYWI5Zi02MDQ3YjA1OTI5NjAiLCJpZCI6NjEwNTMsImlhdCI6MTYyNTY0ODgwMX0.BfdY8ePnShWrZomg9sv4dz8G5EG28Jva1dVFgmE7En4';
            viewer = new Cesium.Viewer(this.initId,{
                animation: false, //创建动画部件
                shouldAnimate : true,
                orderIndependentTranslucency: false,
                contextOptions: {
                webgl: { alpha: true
                }},
              navigation: false,
              enableLighting: true
            });
            //去掉超图supermap
            viewer._cesiumWidget._creditContainer.style.display = "none";
            viewer.cesiumWidget.screenSpaceEventHandler.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_DOUBLE_CLICK)
            viewer.cesiumWidget.screenSpaceEventHandler.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_CLICK)
            viewer.scene.globe.enableLighting = true
            viewer.scene.backgroundColor = new Cesium.Color(0.0, 0.0, 0.0, 0.0)
            viewer.imageryLayers.removeAll()
            const labelImagery = new Cesium.TiandituImageryProvider({
              mapStyle : Cesium.TiandituMapsStyle.TER_C, //天地图全球中文注记服务（经纬度投影）
              token: '4a00a1dc5387b8ed8adba3374bd87e5e'
            });
            viewer.imageryLayers.addImageryProvider(labelImagery);


            var handler = new Cesium.ScreenSpaceEventHandler(viewer.scene.canvas);
            var scene = viewer.scene
            var ellipsoid = scene.globe.ellipsoid
            handler.setInputAction(function(movement){
                let click_position =  viewer.scene.camera.pickEllipsoid(movement.endPosition,ellipsoid);
                let carto_position = ellipsoid.cartesianToCartographic(click_position);
                that.longitude_x = Cesium.Math.toDegrees(carto_position.longitude);
                that.longitude_y = Cesium.Math.toDegrees(carto_position.latitude);
                that.longitude_x = that.longitude_x.toFixed(6)
                that.longitude_y = that.longitude_y.toFixed(6)
            },Cesium.ScreenSpaceEventType.MOUSE_MOVE);
            try {
                this.getLIST()
            } catch (error) {
                console.log(error);
            }
        },
        getLIST(){
            this.options = this.productFileList
            let first = this.options[0].fileName.split('.')[0]
            this.value = this.options[0].fileCreateTime
            const urlcc = this.iserverHeader+this.url+'/'+first
            var provider = new Cesium.SuperMapImageryProvider({url : urlcc});
            viewer.imageryLayers.addImageryProvider(provider);
        }
    },
    created(){

    },
    mounted(){
        this.initMap()
    }
}
</script>

<style lang="scss" scoped>
/deep/ .xixi{
  .el-input__inner{
    color: black;
  }
}
.changeMap{
    position: absolute;
    right: 24px;
    bottom: 14px;
    z-index: 100000;
}
.map{
    width: 100%;
    height: 100%;
    .loction{
        position: absolute;
        left: 12px;
        top: 0px;
        z-index: 100000;
        color: white;
        height: 29px;
        padding: 0 12px;
        background-image: url("../../../assets/image/product-detail-dialog/矩形 3 拷贝.png");
        background-size: 100% 100%;
    }
    .le
    .legend-my{
        position: absolute;
        left: 0;
        bottom: 0px;
        padding-left: 12px;
        width: 120px;
        z-index: 100000;
        .left{
            width: 24px;
            height: 160px;
            position: relative;
            background:linear-gradient(rgba(200,0,0,1)0%,rgba(255,231,0,1)25%,rgba(156,246,99,1)50%,rgba(0,48,254,1)75%,rgba(7,23,249, 1)100%);
            .right{
                width: 36px;
                height: 100%;
                position: absolute;
                top: 0;
                left: 30px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
            }
        }
    }
    .time-step{
      position: absolute;
      left: 260px;
      bottom: 10px;
      z-index: 100000;
    }
}
</style>
